import { render, staticRenderFns } from "./AllFee.vue?vue&type=template&id=4cecb442&"
import script from "./AllFee.vue?vue&type=script&lang=js&"
export * from "./AllFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports